import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { FloorType } from 'src/app/services/portal-api.service';

export enum FloorTypeOptions {
  FirstFloorPlus = 'FirstFloorPlus',
  GroundFloor = 'GroundFloor',
  SemiBasement = 'SemiBasement',
  Basement = 'Basement',
}

export interface ApartmentOptionButton {
  id: FloorTypeOptions;
  title: string;
  icon?: string;
  isToggled: boolean;
  floor: number;
  floorType?: FloorType
}

@Component({
  selector: 'app-apartment-options',
  templateUrl: './apartment-options.component.html',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
})
export class ApartmentOptionsComponent implements OnInit {
  @Output() SelectedItem: EventEmitter<ApartmentOptionButton> = new EventEmitter();
  @Input() floor?:number;
  @Input() floorType?: FloorType;
  @Input() FillterApartmentsOptions?:(buttons:ApartmentOptionButton[])=>ApartmentOptionButton[]
  SelectedButton: FloorTypeOptions | undefined = undefined

  FilteredButtons(): ApartmentOptionButton[]{
    if(this.FillterApartmentsOptions){
      return this.FillterApartmentsOptions(this.Buttons)
    }
    return this.Buttons
  } 

  private Buttons: ApartmentOptionButton[] = [
    {
      id: FloorTypeOptions.FirstFloorPlus,
      title: 'shared.floor-dropdown.options.FirstFloorPlus',
      isToggled: false,
      floor: 1
    },
    {
      id: FloorTypeOptions.GroundFloor,
      title: 'shared.floor-dropdown.options.GroundFloor',
      isToggled: false,
      floor: 0
    },
    {
      id: FloorTypeOptions.SemiBasement,
      title: 'shared.floor-dropdown.options.SemiBasement',
      isToggled: false,
      floor: -1,
      floorType: FloorType.SemiBasement
    },
    {
      id: FloorTypeOptions.Basement,
      title: 'shared.floor-dropdown.options.Basement',
      isToggled: false,
      floor: -1,
      floorType: FloorType.Basement
    },
  ];

  constructor() {}
  ngOnInit(): void {
    
    const currentButtons = this.FillterApartmentsOptions ? this.FillterApartmentsOptions(this.Buttons) : this.Buttons;
    let selectedButton: ApartmentOptionButton | undefined;
    if (this.floorType) {
      selectedButton = currentButtons.find((x) => x.floorType === this.floorType && x.floor === this.floor);
    } else {
      selectedButton = currentButtons.find((x) => x.floor === this.floor);
    }
    if (selectedButton) {
      this.SelectedButton = FloorTypeOptions[selectedButton.id];
    }

    this.toggleSelect(this.SelectedButton)
  }

  toggleSelect(buttonId?: FloorTypeOptions) {
    if(!buttonId) return;
    var button = this.Buttons.find((x) => x.id == buttonId);
    if (button == null) return;

    this.Buttons.forEach((button) => {
      button.isToggled = button.id === buttonId;
    });

    this.SelectedButton = button.isToggled ? button.id : undefined;

    if (this.SelectedButton) {
      this.SelectedItem.emit(button);
    } else {
      this.SelectedItem.emit(undefined);
    }
  }
}
